import graphql from "babel-plugin-relay/macro";
import { commitMutation } from "react-relay";

const mutation = graphql`
  mutation DeletePolicyMutation($input: DeleteDocumentInput!) {
    deleteDocument(input: $input) {
      ok
      reasons
    }
  }
`;

export const deletePolicy = (environment, input, callback) => {
  const variables = {
    input
  };

  commitMutation(environment, {
    mutation,
    variables,
    onCompleted: (response, errors) => {
      callback(response, errors);
    },
    onError: err => {
      throw new Error(err);
    }
  });
};
